import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { successfulCreate, requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import ActionButton from '@/components/action_button/Index.vue';
import { AlertType } from '@/helpers/entities/enums/AlertType';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import AppAdministratorsQuery from '@/plugins/graphql/queries/app-administrators.gql';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AppAdminCreateMutation from '@/plugins/graphql/mutations/app-admin-create.gql';
import BaseCardSectionHeader from '@/components/dashboard_card/BaseCardSectionHeader.vue';
import CachedAppAdministratorsMixin from '@/helpers/vue_mixins/CachedAppAdministratorsMixin';
import FormHeader from '@/components/v2/FormHeader.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { required } from 'vuelidate/lib/validators';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import { AdminRoles } from '@/helpers/entities/enums/AdminRoles';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let MemberForm = class MemberForm extends mixins(RouteParamsAppMixin, FormMixin, CachedAppAdministratorsMixin, FormValidationsMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.modelName = 'Administrator';
        this.section = 'Invite Members';
        this.subTitle = 'Administrators';
        this.existingUser = false;
        this.form = {
            firstName: null,
            lastName: null,
            email: null,
            role: AdminRoles.editor,
        };
    }
    get adminRoleSelection() {
        return [
            selectOptionBuilder(AdminRoles.editor),
            selectOptionBuilder(AdminRoles.courier),
            selectOptionBuilder(AdminRoles.switchAsOwner),
        ];
    }
    formCallback() {
        const message = this.existingUser
            ? successfulCreate(this.modelName)
            : 'Successfully Sent Invitation';
        this.toggleAlert(message, AlertType.success);
        this.$router.push({ name: 'members' });
    }
    async submit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.isRequestOnProcess = true;
            const mutation = this.createAppAdmin();
            await mutation
                .then(() => {
                this.formCallback();
            })
                .catch((error) => {
                this.errorNotification(error.message);
            })
                .finally(() => {
                this.isRequestOnProcess = false;
            });
        }
    }
    async createAppAdmin() {
        return this.$apollo.mutate({
            mutation: AppAdminCreateMutation,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    email: this.form.email,
                    role: this.form.role,
                },
            },
            update: (store, result) => {
                const appAdmin = result.data.appAdminCreate.user;
                if (appAdmin) {
                    this.existingUser = true;
                }
            },
            refetchQueries: [
                {
                    query: AppAdministratorsQuery,
                    variables: {
                        appUUID: this.appUUID,
                    },
                },
            ],
        });
    }
    get firstNameErrors() {
        const errors = [];
        if (!this.$v.form.firstName.$dirty) {
            return errors;
        }
        if (!this.$v.form.firstName.required) {
            const msg = requiredProperty('First Name');
            errors.push(msg);
        }
        if (!this.$v.form.firstName.invalidFirstName) {
            const msg = 'First Name Contains Invalid Characters';
            errors.push(msg);
        }
        return errors;
    }
    get lastNameErrors() {
        const errors = [];
        if (!this.$v.form.lastName.$dirty) {
            return errors;
        }
        if (!this.$v.form.lastName.required) {
            const msg = requiredProperty('Last Name');
            errors.push(msg);
        }
        if (!this.$v.form.lastName.invalidLastName) {
            const msg = 'Last Name Contains Invalid Characters';
            errors.push(msg);
        }
        return errors;
    }
    hasUrl(name) {
        const urlRegex = new RegExp('([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?');
        return !urlRegex.test(name);
    }
};
MemberForm = __decorate([
    Component({
        components: {
            ActionButton,
            FormHeader,
            BaseCardSectionHeader,
            BaseTextField,
        },
        validations: {
            form: {
                firstName: {
                    required,
                    invalidFirstName() {
                        const vm = this;
                        const { firstName } = this.form;
                        return vm.hasUrl(firstName);
                    },
                },
                lastName: {
                    required,
                    invalidLastName() {
                        const vm = this;
                        const { lastName } = this.form;
                        return vm.hasUrl(lastName);
                    },
                },
                email: {
                    required,
                },
                role: {
                    required,
                },
            },
        },
    })
], MemberForm);
export default MemberForm;
